module.exports = __webpack_public_path__ + "media/react/assets/images/logo-full-white-2b0c059a03260722dd31092c6c3c8b92.png";